<!--
 * @Author: Wangchaoke
 * @Date: 2020-02-12 13:51:51
 * @LastEditTime: 2020-02-24 16:22:09
 * @LastEditors: Please set LastEditors
 * @Description: 用于填写用户信息表单页面
 * @FilePath: /xingmahui_front/src/views/activity/donation_active/userform.vue
 -->
<template>
  <div v-if="authstate" style="height:100%;">
    <div class="formMain" v-show="userInfoShow">
      <div class="formHeader">
        <!--返回-->
        <span></span>
        <!--logo-->
        <div></div>
        <!--标题-->
        <img class="qylogo" src="./../../../assets/images/activity/donationActive/yqlogo.png" alt="">
        <p style="margin:12px 0px 8px 0px;font-size:12px;line-height:1;">妈妈在线申请用户确认信息</p>
      </div>
      <div class="formBody">
        <!--白色区域-->
        <div class="formBodyWrap">
          <ul>
            <li>
              <h4 class="baseInfo">基本信息</h4>
              <dl>
                <dd>
                  <div class="input">
                    <input type="text" @blur="inputBlur" readonly placeholder="姓名" v-model="userName">
                  </div>
                </dd>
                <dd>
                  <span>孕产状态：</span>
                  <span>{{radio == "1" ? "孕期" : "产后三个月"}}</span>
                </dd>
                <dd>
                  <div class="option">
                    <input type="text" v-model="date" readonly />
                  </div>
                  <span class="optionTitle">宝宝生日/预产期：</span>
                </dd>
              </dl>
            </li>
            <li>
              <h4 class="examineInfo">审核信息</h4>
              <dl>
                <dd>
                  <div class="idCardImg" v-if="!IDCardPhoto">点击上传</div>
                  <div v-else-if="IDCardPhoto" class="idCardImgelseWrap">
                    <div class="idCardImgelse">
                      <img :src="IDCardPhotoserve" style="width:100%;height:100%;">
                    </div>
                  </div>
                  <span class="idCardImgTitle">上传身份证正面照片</span>
                </dd>
                <dd>
                  <div class="idCardImg" v-if="!BirthProof">点击上传</div>
                  <div v-else-if="BirthProof" class="idCardImgelseWrap">
                    <div class="idCardImgelse">
                      <img :src="BirthProofserve" style="width:100%;height:100%;">
                    </div>
                  </div>
                  <span class="bornTitle">上传出生证明<br />
                    /孕检证明</span>
                </dd>
                <dd>
                  <div class="idCardNumber">
                    <input type="text" @blur="inputBlur" readonly v-model="cardNum">
                  </div>
                  <span>出生证明编号<br />
                    /孕检证明编号</span>
                </dd>
              </dl>
            </li>
            <li>
              <h4 class="addressInfo">地址信息</h4>
              <dl>
                <dd>
                  <div class="optionInput">
                    <input type="text" v-model="areaModel" readonly />
                  </div>
                </dd>
                <dd>
                  <div class="input">
                    <input type="text" @blur="inputBlur" readonly="readonly" v-model="rqname">
                  </div>
                </dd>
                <dd>
                  <div class="input">
                    <input type="text" @blur="inputBlur" readonly="readonly" v-model="doorNumber">
                  </div>
                </dd>
              </dl>
            </li>
            <li style="padding-bottom:40px;">
              <h4 class="contactInfo">联系方式</h4>
              <dl>
                <dd>
                  <div class="input">
                    <input type="number" pattern="\d*" @blur="inputBlur" readonly="readonly" maxlength="11" onkeyup="this.value=this.value.replace(/\D/g,'')" v-model="mobile">
                  </div>
                </dd>
              </dl>
            </li>
          </ul>
          <div class="formFooter">
            <p @click="UserSubmit()">
              <a href="javascript:void(0)">确认</a>
            </p>
          </div>
        </div>
      </div>
      <!-- 正在提交中 -->
      <div class="submit_loading" v-show="submitLoading">
        <van-loading type="spinner" size="50px" color="#ffffff" vertical>正在提交中...</van-loading>
      </div>
    </div>
    <activity-result v-show="resultShowWx" :resultCode="resultCode" :channelName="channelName" :pageSource="pageSource" @userAgainWrite="againWrite" @goBack="toBack"></activity-result>
    <!-- app端 -->
    <activity-result-app v-show="resultShow" :commitShow="commitShow" :channelName="channelName" :successShow="successShow" :pageSource="pageSource" @goBack="toBack"></activity-result-app>
  </div>
</template>

<script>
import { RadioGroup, Radio, DatetimePicker, Area } from 'vant';
/**
 * getCookie 获取本地cookie插件
 */
import { getCookie, is_weixin } from '@/assets/js/common.js';
/**
 * 调起微信相册
 */
import wxJsSet from './../../../assets/js/DonatewxConfig.js'
/**
 * Api接口
 */
import API from "@/utils/axiosApi/harvardApi";
/**
 * 新增Api接口
 */
import YAPI from "@/utils/axiosApi/donationApi";
/**
* 引入用户检查结果显示组件
*/
import activityResultApp from "@/components/activity/donation_active/activityResultApp.vue";
import activityResult from "@/components/activity/donation_active/activityResult.vue";
import channelData from './../../../utils/mockData/channelData';
export default {
  components: {
    activityResultApp,
    activityResult
  },
  data () {
    return {
      // 防止链接复制出去
      commitShow: false,
      // 防止页面闪屏 初始化页面为空白
      authstate: false,
      // 用户的openid
      userOpenid: null,
      // 用户的crmId
      userCrmId: null,
      // 用户姓名
      userName: null,
      // 身份证照片
      IDCardPhoto: null,
      IDCardPhotoserve: null,
      // 手机号
      mobile: null,
      // 出生证明
      BirthProof: null,
      BirthProofserve: null,
      // 出生/产检证明 编号
      cardNum: null,
      //默认radio
      radio: '1',
      //选择时间值
      date: '',
      //选择地区值
      area: '',
      //时间显示状态
      dateShow: false,
      //地区显示状态
      areaShow: false,
      //地区显示json
      areaList: {},
      //地区显示于表单
      areaModel: '',
      // 小区名称
      rqname: '',
      // 门牌号
      doorNumber: '',
      // 结果组件显示与隐藏
      userInfoShow: false,
      // app端组件状态
      resultShow: false,
      // 微信端组件状态
      resultShowWx: false,
      // 结果code
      resultCode: null,
      // 提交中遮罩层
      submitLoading: false,
      // 渠道名称
      channelQcode: null,
      channelName: "",
      pageSource: null,
      isWeixin: null, //是微信端还是APP
      pageSourceName: null,//页面来源名称
      orderID: null,//订单id
      successShow: false,
      UserInfo: null
    }
  },
  /**
   * @description: 导航守卫，进入页面之前执行
   */
  beforeRouteEnter (to, from, next) {
    window.scrollTo(0, 0);
    next(vm => {
      if (vm.is_weixin()) {//微信中
        if (vm.getCookie("xmh_openid") == null || vm.getCookie("xmh_openid") == "") {//判断有没有openId
          location.href = "/xmh/v2/wechat/oauth2/authorize?url=" + encodeURIComponent(window.location.href);
        } else {
          // 有openid获取用户信息
          vm.userOpenid = vm.getCookie('xmh_openid');
          vm.authstate = true;
          // 从本地获取用户信息
          vm.UserInfo = JSON.parse(localStorage.getItem('userInfo'));
          if (!vm.UserInfo || vm.UserInfo == "" || !vm.UserInfo.mobile || vm.UserInfo.mobile == "") {
            API.goLogin({}, { openId: vm.getCookie('xmh_openid') }, res => {
              if (res.code == "200") {
                // 赋值用户信息
                vm.UserInfo = res.data;
                vm.userCrmId = res.data.crm_id;
                localStorage.setItem('userInfo', JSON.stringify(res.data));
                vm.getuserSearch();
              } else {
                vm.commitShow = true;
                vm.resultShow = true;
                vm.userInfoShow = false;
              }
            })
          } else {
            vm.userCrmId = vm.UserInfo.crm_id;
            vm.getuserSearch();
          }
        }
      } else {
        vm.authstate = true;
      }
    })
  },
  mounted () {

    var shareLink = location.origin + "/donationMilk";
    if (this.$route.query.pageSource) {
      this.pageSource = this.$route.query.pageSource;
      this.channelName = channelData.channelLogoAppList[this.pageSource] || channelData.channelLogoList[this.pageSource] || channelData.channelNoLogoList[this.pageSource];
      this.channelQcode = "https://image-mom.feihe.com/channelQcode/" + this.$route.query.pageSource + ".jpg";
      // shareLink = location.origin+"/donationMilk?pageSource="+this.pageSource;
    }
    var that = this;
    var shareDataParams = {
      shareLink: shareLink,
      shareDesc: '中国飞鹤累计捐赠2亿元款物。点击领取',
      shareTitle: '飞鹤直送一亿奶粉，孕妈领取专属免疫力',
      imgUrl: "https://image-mom.feihe.com/wxshare/donation.png",//必须是绝对路径
      shareSuccess: function () {
        that.$toast({
          duration: 2000,
          message: '分享成功'
        })
      }
    }
    wxJsSet.wxShare(this, shareDataParams);

    this.pageSourceName = this.channelName ? this.channelName : "星妈会";

    var winHeight = $(window).height();  //获取当前页面高度
    $(window).resize(function () {
      var thisHeight = $(this).height();
      if (winHeight - thisHeight > 140) {
        //键盘弹出
        $('.formFooter').css('position', 'absolute');
      } else {
        //键盘收起
        $('.formFooter').css({ 'position': 'fixed' });
      }
    })
  },
  methods: {
    // 获取用户填写信息
    getuserSearch () {
      YAPI.searchUserInfo({}, { mobile: this.UserInfo.mobile }, res => {
        if (res.code == "200") {
          this.userInfoShow = true;
          this.resultShowWx = false;
          const { memberName, pregnant, babyBirth, idCardFrontUrl, antenatalExaminationPicUrl, cardNum, provinceName, cityName, districtName, street, address, memberMobile, id } = res.data;
          this.userName = memberName
          this.radio = pregnant;
          this.date = babyBirth;
          this.IDCardPhoto = idCardFrontUrl;
          this.IDCardPhotoserve = idCardFrontUrl;
          this.BirthProof = antenatalExaminationPicUrl;
          this.BirthProofserve = antenatalExaminationPicUrl;
          this.cardNum = cardNum;
          this.areaModel = provinceName + cityName + districtName;
          this.rqname = street;
          this.doorNumber = address;
          this.mobile = memberMobile;
          this.orderID = id;
        } else if (res.code == "201" || res.code == "202" || res.code == "203" || res.code == "204") {
          this.resultCode = res.code;
          this.userInfoShow = false;
          this.resultShowWx = true;
        } else {
          this.userInfoShow = true;
          this.resultShowWx = false;
        }
      })
    },
    // 用户状态为203时，点击重新填写
    againWrite () {
      // if(new Date().getHours()<9){
      //     this.$toast({
      //         duration:4000,
      //         message:'9点限量开放，先到先得！'
      //     })
      // }else if(new Date().getHours()>=9 && new Date().getHours()<15){ //9点到下午15点
      //     this.checkCount("今日上午已达上限，信息无法提交。\n下午15点限量开放，先到先得！");
      // }else{
      //     this.checkCount("您好，申领活动已结束");
      // }
      this.$toast({
        duration: 4000,
        message: '您好，申领活动已结束'
      })
    },
    checkCount (message) {
      // 9点之后
      YAPI.countMember({}, res => {
        if (!res.data) {
          this.$toast({
            duration: 4000,
            message: message
          })
        } else {
          this.$router.push({ path: "/donationMilk/userInfo?isAgain=true" });
          gio('track', "donationmilk_reapply", { "pageSource_var": "星妈会", "isWeixin": "weixin" });//捐奶粉活动-重新gio埋点
        }
      }, error => {
        this.$toast({
          duration: 2000,
          message: '活动太火爆了，请稍后重试。'
        })
      })
    },
    // 解决输入框收回时会有空白区域的问题
    inputBlur () {
      $(window).scrollTop($(window)[0].scrollY);
    },
    // 用户提交申请
    UserSubmit () {
      this.$toast({
        duration: 4000,
        message: '您好，申领活动已结束'
      });
      // YAPI.userOrderConfirm({},{
      //     "id":this.orderID,
      //     "openId":this.userOpenid,
      //     "crmId":this.userCrmId
      // },res=>{
      //     if(res.code == "200"){
      //         this.userInfoShow = false;
      //         this.resultShow = true;
      //         this.successShow = true;
      //     }else{
      //         that.$toast({
      //             duration:2000,
      //             message:'确认失败'
      //         })
      //     }
      // })
    },
    // 返回上一页
    toBack () {
      if (this.pageSource) {
        location.href = "/donationMilk?pageSource=" + this.pageSource;
      } else {
        location.href = "/donationMilk";
      }
    },
    getCookie, is_weixin
  },

}
</script>

<style lang="less" scoped>
.qylogo {
  width: 210px;
  height: 30px;
}
dd {
  cursor: pointer;
}
.bg {
  background-color: rgba(0, 0, 0, 0.5);
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
}
.xystyle {
  width: 334px;
  height: 317px;
  box-sizing: border-box;
  padding: 45px 30px 40px 30px;
  background-color: #fff;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  border-radius: 20px;
  line-height: 23px;
  font-size: 14px;
  span {
    display: inline-block;
    width: 25px;
    height: 25px;
    border-radius: 50%;
    position: absolute;
    right: 30px;
    top: -45px;
    border: 1px solid #fff;
    color: #fff;
    text-align: center;
    line-break: 20px;
    font-size: 20px;
    font-weight: bold;
  }
}
.formMain {
  width: 100%;
  position: relative;
  overflow: hidden;

  // 正在提交中
  .submit_loading {
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    z-index: 9999;
    .van-loading {
      width: 140px;
      height: 150px;
      position: fixed;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      margin: auto;
      color: #ffffff;
    }
    .van-loading__text {
      font-size: 18px;
      color: #ffffff;
    }
  }
}
.formHeader {
  width: 100%;
  height: 207px;
  background: url(../../../assets/images/activity/donationActive/form_bg.jpg)
    no-repeat left top #feeb2d;
  background-size: 100% 100%;
  box-sizing: border-box;
  padding-top: 39px;
  padding-left: 23px;
  span {
    width: 12px;
    height: 23px;
    // background: url(../../../assets/images/activity/donationActive/form_arr_l.png) no-repeat left center;
    background-size: 100% 100%;
    display: block;
    margin-bottom: 25px;
  }
  div {
    width: 124px;
    height: 25px;
    background: url(../../../assets/images/activity/donationActive/form_logos.png)
      no-repeat center center;
    background-size: 100% auto;
    margin-bottom: 30px;
    margin-left: 18px;
  }
  h1 {
    font-size: 22px;
    line-height: 1;
    color: #073190;
  }
}
.formBody {
  background: #feeb2d;
  .formBodyWrap {
    margin: 0 20px;
    border-radius: 30px 30px 0 0;
    background: #fff;
    padding: 22px 20px 40px 20px;
    ul {
      li {
        margin-bottom: 38px;
        h4 {
          margin-left: 6px;
          line-height: 22px;
          font-size: 18px;
          color: #073190;
          padding-left: 28px;
          margin-bottom: 22px;
          &.baseInfo {
            background: url(../../../assets/images/activity/donationActive/form_icon1.png)
              no-repeat left center;
            background-size: 18px 18px;
          }
          &.examineInfo {
            background: url(../../../assets/images/activity/donationActive/form_icon2.png)
              no-repeat left center;
            background-size: 18px 18px;
          }
          &.addressInfo {
            background: url(../../../assets/images/activity/donationActive/form_icon3.png)
              no-repeat left center;
            background-size: 18px 18px;
          }
          &.contactInfo {
            background: url(../../../assets/images/activity/donationActive/form_icon4.png)
              no-repeat left center;
            background-size: 18px 18px;
          }
        }
        .input {
          width: 100%;
          height: 51px;
          border: 1px solid #b5b5b5;
          border-radius: 10px;
          overflow: hidden;
          padding: 0 20px;
          box-sizing: border-box;
          input {
            border: 0;
            width: 100%;
            font-size: 17px;
            color: #999999;
            padding: 13px 0;
          }
        }
        .codeInput {
          width: 165px;
          margin-top: 13px;
          float: left;
        }
        .sendCode {
          width: 113px;
          height: 51px;
          background: linear-gradient(
            90deg,
            rgba(255, 236, 57, 1) 0%,
            rgba(255, 231, 0, 1) 100%
          );
          border-radius: 10px;
          float: right;
          margin-top: 13px;
          font-size: 14px;
          font-weight: bold;
          color: rgba(153, 153, 153, 1);
          line-height: 51px;
          text-align: center;
          .van-count-down {
            color: @expertFontColor153;
            font-size: @indexFontSize14;
            margin-top: 1px;
            height: 51px;
            line-height: 51px;
            display: inline-block;
          }
        }
        .optionInput {
          width: 100%;
          height: 51px;
          border: 1px solid #b5b5b5;
          border-radius: 10px;
          overflow: hidden;
          padding: 0 35px 0 20px;
          box-sizing: border-box;
          // background: url(../../../assets/images/activity/donationActive/form_arr_d.png) no-repeat 260px center;
          background-size: 16px 10px;
          input {
            border: 0;
            width: 100%;
            line-height: 50px;
            font-size: 17px;
            color: #999999;
          }
        }
        dd {
          clear: both;
          margin-bottom: 24px;
          span {
            font-size: 15px;
            color: #333333;
            font-weight: bold;
            float: left;
            &.idCardImgTitle {
              line-height: 58px;
            }
            &.bornTitle {
              padding-top: 10px;
            }
          }
          .van-radio-group {
            float: right;
            .van-radio {
              float: left;
              font-size: 14px;
              color: #333333;
              line-height: 24px;
              font-weight: bold;
              margin-left: 10px;
            }
          }
          .optionTitle {
            line-height: 34px;
          }
          .option {
            width: 140px;
            height: 34px;
            line-height: 34px;
            overflow: hidden;
            border: 1px solid #b5b5b5;
            padding: 0 25px 0 10px;
            box-sizing: border-box;
            float: right;
            background-size: 16px 10px;
            input {
              border: none;
              width: 100%;
              line-height: 34px;
              font-size: 17px;
              color: #999999;
              background-color: transparent !important;
            }
          }
          .idCardImg {
            float: right;
            width: 97px;
            height: 59px;
            background: #f2f2f2;
            border-radius: 3px;
            font-size: 14px;
            color: #999999;
            padding-top: 10px;
            box-sizing: border-box;
            text-align: center;
            &:before {
              display: block;
              width: 20px;
              height: 16px;
              margin: 0 auto 6px;
              content: '';
              background: url(../../../assets/images/activity/donationActive/form_icon7.png)
                no-repeat center top;
              background-size: 20px 16px;
            }
          }
          .idCardImgelseWrap {
            float: right;
            width: 97px;
            padding-top: 10px;
            text-align: center;
          }
          .idCardImgelse {
            width: 97px;
            min-height: 97px;
            height: auto;
            img {
              width: 100%;
              height: auto;
            }
          }
          .resetButton {
            display: inline-block;
            margin-top: 6px;
            color: #073190;
            padding-right: 16px;
            line-height: 18px;
            background: url(../../../assets/images/activity/donationActive/icon_reset.png)
              no-repeat right center;
            background-size: auto 12px;
            text-align: center;
          }
          .idCardNumber {
            float: right;
            width: 163px;
            height: 32px;
            border: 1px solid #b5b5b5;
            border-radius: 4px;
            overflow: hidden;
            padding: 0 9px;
            box-sizing: border-box;
            input {
              border: 0;
              width: 100%;
              font-size: 14px;
              color: #999999;
              padding: 6px 0;
            }
          }
          &:after {
            clear: both;
            content: '';
            width: 100%;
            display: block;
            height: 1px;
            font-size: 1px;
          }
          &:last-child {
            margin-bottom: 0;
          }
        }
      }
    }
  }
}
.formFooter {
  width: 100%;
  height: 70px;
  position: fixed;
  background-color: #fff;
  bottom: 0;
  left: 0;
  text-align: center;
  padding: 0px 40px 13px 40px;
  box-sizing: border-box;
  p {
    color: #fff;
    width: 100%;
    height: 50px;
    border-radius: 10px;
    background: linear-gradient(
      -90deg,
      rgba(32, 61, 171, 1),
      rgba(39, 76, 213, 1)
    );
    font-size: 20px;
    line-height: 50px;
    margin: 0 auto;
  }
  div {
    width: 120%;
    padding-top: 17px;
    font-size: 12px;
    transform: scale(0.92);
    -webkit-transform: scale(0.92); /*兼容-webkit-引擎浏览器*/
    -moz-transform: scale(0.92); /*兼容-moz-引擎浏览器*/
    margin-top: -10px;
    margin-left: -12px;
  }
}
.datePiker,
.areaPiker {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
}
</style>
